function addClassToFooterIfRibbonExists() {
  const ribbon = document.querySelector( '.e-stn--ribbon' );
  const footer = document.querySelector( 'footer' );

  if ( !footer ) return;

  if ( ribbon ) {
    footer.classList.add( 'add-ribbon-after' );
  } else {
    footer.classList.remove( 'add-ribbon-after' ); // Optional: remove if ribbon not present
  }
}

// Run on load
window.addEventListener( 'load', addClassToFooterIfRibbonExists );
